<script lang="ts" setup>
import { inject, ref } from "vue"
import { v4 as uuidv4 } from "uuid"
import { defaultsDeep } from "lodash-es"

interface ComponentProps {
  option?: {
    symbol: string
    color?: string
    opacity?: number
  }
  effectOpt?: {
    show: boolean
    period: number
    trailLength: number
    symbol: string
    symbolSize: number
  }
  lineStyleOpt?: {
    normal: {
      color: string
      width: number
      opacity: number
      curveness: number
    }
  }
}

const props = withDefaults(defineProps<ComponentProps>(), {
  option: () => ({
    symbol: "pin",
    color: "#a6c84c",
  }),
  // effect: () => ({
  //   show: true,
  //   period: 8,
  //   trailLength: 0,
  //   symbol: "arrow",
  //   symbolSize: 10,
  // }),
  // lineStyle: () => ({
  //   normal: {
  //     color: "#a6c84c",
  //     width: 3,
  //     opacity: 0.5,
  //     curveness: 0.2,
  //   },
  // }),
})

const coordinateSystem = inject("coordinateSystem") as string
const updateSeries = inject("updateSeries") as any

const effect = ref<any>({
  show: true,
  period: 8,
  trailLength: 0,
  symbol: "arrow",
  symbolSize: 10,
})

const lineStyle = ref<any>({
  color: "#a6c84c",
  width: 3,
  opacity: 0.5,
  curveness: 0.2,
})

if (!props.effectOpt && !props.lineStyleOpt) {
  switch (props.option.symbol) {
    case "pin": {
      effect.value = {
        show: true,
        period: 4,
        trailLength: 0.5,
        symbol: "pin",
        symbolSize: 4,
        color: props.option.color,
      }
      lineStyle.value = {
        show: true,
        width: 1, //尾迹线条宽度
        opacity: props.option.opacity || 0, //尾迹线条透明度
        curveness: 0.3, //尾迹线条曲直度
        color: "#44add00f", // 飞线颜色
      }
      break
    }
    case "arrow": {
      effect.value = {
        show: true,
        period: 8,
        trailLength: 0,
        symbol: "arrow",
        symbolSize: 10,
      }
      lineStyle.value = {
        color: props.option.color,
        width: 2,
        opacity: props.option.opacity || 0.5,
        curveness: 0.2,
      }
      break
    }
  }
} else {
  if (props.effectOpt) {
    effect.value = defaultsDeep(props.effectOpt, effect.value)
  }
  if (props.lineStyleOpt) {
    lineStyle.value = defaultsDeep(props.lineStyleOpt, lineStyle.value)
  }
}

const linesConfig = ref({
  id: uuidv4(),
  type: "lines",
  coordinateSystem,
  zlevel: 2,
  symbol: "circle",
  symbolSize: 10,
  effect: effect.value,
  lineStyle: lineStyle.value,
  //线数据集,需要转换数据
  data: [] as any[],
})

defineExpose({
  setData: (opt: { data: { coords: [number, number][] }[] }) => {
    linesConfig.value.data = opt.data
    updateSeries(linesConfig.value)
  },
})
</script>
